var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('body',{staticClass:"has-navbar-fixed-top"},[_c('Navbar',{staticClass:"is-fixed-top"}),_c('div',{staticClass:"router-view"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }